import { render, staticRenderFns } from "./activitygroup.vue?vue&type=template&id=c3da2c3e"
import script from "./activitygroup.vue?vue&type=script&lang=js"
export * from "./activitygroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports